// extracted by mini-css-extract-plugin
module.exports = {"button":"button__3AkJY","dialogBody":"dialogBody__boHpi","dialogHeader":"dialogHeader__uc6Hu","form":"form__WRyJQ"};